/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store";
import {IUser, TPermissions} from "./types";

interface IState {
  currentUser: IUser
}

const initialState: IState = {
  currentUser: {}
} as IState

const slice = createSlice({
  name: 'accessControlSlice',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUser>) => void (state.currentUser = action.payload),
  }
})

const selectAccessControlState = (state: RootState): IState => state.accessControl
const selectCurrentUser = (state: RootState): IUser => selectAccessControlState(state).currentUser
const selectCurrentUserPermissions = (state: RootState): TPermissions => selectCurrentUser(state).permissions

const {actions, reducer} = slice
export {
  selectAccessControlState,
  selectCurrentUser,
  selectCurrentUserPermissions,
}
export const {
  setUser
} = actions

export default reducer
